const operatingCostPositionAllocation = `
    title
    positionId
    agreedDistributerType
    agreedDistributerTypeOther
`;

export default operatingCostPositionAllocation;
